import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const DraggableItem = styled.div`
  background: white;
  padding: ${pxToRem(5)};
  margin: ${pxToRem(10)} 0;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

export const DroppableZone = styled.div`
  background: #eff0f0;
  padding: ${pxToRem(10)};
`;
